import { i18n } from 'core/localization';

export function getDayText(day) {
	return i18n(day.charAt(0) + day.slice(1).toLowerCase());
}
